import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function PinIcon(props) {
    return (
        <SvgIcon {...props}>
            <path clipRule="evenodd" d="M5 8.91765C5 5.09713 8.134 2 12 2C15.866 2 19 5.09713 19 8.91765C19 9.18348 18.981 9.44438 18.952 9.70132C18.458 16.276 12 22 12 22C12 22 5.542 16.276 5.048 9.70132C5.019 9.44438 5 9.18348 5 8.91765ZM12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12Z" fillRule="evenodd" />
        </SvgIcon>
    );
}

export default PinIcon;
